import { Icon } from "@/components/icons/Icon";
import { useTranslate } from "@/hooks/use-translate/useTranslate";
import type { FC } from "react";
import type { InpectionPhase } from "../../inspection.d";

interface BloquedAnswerMobileProps {
  phase: InpectionPhase;
}

const BloquedAnswerMobile: FC<BloquedAnswerMobileProps> = ({ phase }) => {
  const translate = useTranslate();
  return (
    <div className="flex flex-col px-4 py-2 bg-ib-gray-lightest text-ib-gray-dark-2 ">
      <div className="flex items-center">
        <Icon name="lockClose" className="size-4" />
        <h4 className="font-ib-bold p-2">{phase.phaseName}</h4>
      </div>
      <div className="text-ib-gray-dark-2 flex flex-col items-center justify-center border border-dashed border-ib-gray-borders">
        <h4 className="text-md">{translate("blocked")}</h4>
      </div>
    </div>
  );
};

export default BloquedAnswerMobile;
